<template>
  <div :class="{'has-logo':showLogo}">
    <div class="menu-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        background-color="#ffffff"
        text-color="#303133"
        :unique-opened="false"
        active-text-color="#409EFF"
        :collapse-transition="false"
        mode="horizontal"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" v-show="route.type == 'project' || route.type == 'normal'" />
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  text-align: center;
  .menu-item {
    margin: 12px 20px 0;
    display: inline-block;
    font-size: 15px;
    position: relative;
    vertical-align: middle;
    line-height: 50px;
}
}

</style>
